import moment from "moment";

import { DateTimeWithPrecision } from "@/Common/Models/DateTimeWithPrecision";
import { LifeStageDatePrecisionEnum } from "@/Common/Models/LifeStageDatePrecisionEnum";
import { PatientMedicalItemsHelper } from "@/Patient/Helpers/PatientMedicalItemsHelper";

class MedicalItemDate {
    public date: Date;
    public dateText: string;
    public datePrecision: LifeStageDatePrecisionEnum;
    public isDateApproximative: boolean;

    constructor(init?: Partial<MedicalItemDate>) {
        Object.assign(this, init);
    }

    public onDateChange(date: DateTimeWithPrecision, allowApprox: boolean = true): MedicalItemDate {
        if (date.value) {
            this.date = moment(date.value).toDate();
            this.datePrecision = date.precision;

            if (date.isFromDateSelector) {
                this.dateText = moment(date.value).format("YYYY-MM-DD");
            }
            else if (date.isDayPrecision) {
                this.dateText = moment(date.value).format("YYYY-MM-DD");
                this.isDateApproximative = false;
            }
            else if (date.isMonthOrYearPrecision && allowApprox) {
                this.dateText = PatientMedicalItemsHelper.GetLifeStageDateString(date.value, date.precision);
                this.isDateApproximative = true;
            }
            else {
                this.date = null;
                this.dateText = date.text;
                this.isDateApproximative = false;
            }
        }
        else {
            this.date = null;
            this.dateText = IsNullOrWhiteSpace(date.text) ? "" : date.text;
            this.isDateApproximative = false;
        }

        return this;
    }

    public static isValid(date: MedicalItemDate, allowApprox: boolean, allowNullOrEmpty: boolean): boolean {
        if (!date.date)
            return allowNullOrEmpty;

        if (date.isDateApproximative && !allowApprox)
            return false;

        return moment(date.date).isValid();
    }

    public static default(): MedicalItemDate {
        return new MedicalItemDate({
            date: null,
            dateText: "",
            datePrecision: LifeStageDatePrecisionEnum.Day,
            isDateApproximative: false
        });
    }

    public static today(isDateApproximative: boolean = false): MedicalItemDate {
        return new MedicalItemDate({
            date: moment(Date.now()).toDate(),
            dateText: moment(Date.now()).format("YYYY-MM-DD"),
            datePrecision: isDateApproximative
                ? LifeStageDatePrecisionEnum.DayApprox
                : LifeStageDatePrecisionEnum.Day,
            isDateApproximative
        });
    }
}

export { MedicalItemDate };
